
import React, { useId, useState } from "react";
import { Container, Col, Button, FormGroup } from "reactstrap";
import { RawDraftContentState } from "draft-js";
import { ProductName } from "./ProductName";
import { AttribName } from "./AttribName";
import { ProductOptions } from "./ProductOptions";
import { ImagePicker } from "./ImagePicker";
import { FormHelper } from "../../scripts/formhelper";
import { ProductDescription } from "./ProductDescription";
import { SQLEnum } from "../../shared/SQLEnum";
import { ProductDemo } from "./ProductDemo";
import { ProductVisibility } from "./ProductVisibility";
import { ProductCartLimit } from "./ProductCartLimit";
import { App } from "../../app/App";
import {Api} from "../../shared";

import { ProductDelete } from "./Delete";
import { ProductTaxes } from "./ProductTaxes";
import { Tax } from "../../shared/api";
export { ProductDelete } from "./Delete";

export type ItemType = Api.Staff.Product.ItemType;

interface IProps {
	productId?: string;
	isCustom?: boolean;
	isEdit?: boolean;
	onSubmit?: (p: ItemType) => void;
	getProductId?: () => string;
	preset?: ItemType;
	onDelete?: (mergeInto?: Api.Product.ProductSearchedType) => void;
	onClose?: () => void;
}

interface IState {
	ready: boolean;
}

export class AddProduct extends React.Component<IProps, IState>
{
	form = new FormHelper(() => this.forceUpdate());
	form_name = this.form.createRef();
	form_brand_name = this.form.createRef();
	form_category_name = this.form.createRef();
	form_options = this.form.createRef<Api.Staff.Product.ItemOptType[]>();
	form_taxes = this.form.createRef<Tax.TaxType[]>();
	form_gst_aud = this.form.createRef();
	form_vat_gbp = this.form.createRef();
	form_image = this.form.createRef<Api.Files.ImageType>();
	form_desc = this.form.createRef<RawDraftContentState>();
	form_cart_limit = this.form.createRef<[boolean, string]>();
	form_visibility = this.form.createRef();

	constructor(props: IProps) {
		super(props);

		this.state = {
			ready: false,
		};
	}

	isCustom()
	{
		return this.props.isCustom || this.form_visibility.value === "PRIVATE";
	}

	submit()
	{
		let r = this.form.check();

		if(!r) {
			return;
		}

		let product = this.get_product();

		if(this.props.onSubmit) {
			this.props.onSubmit(product);
		}
	}

	async delete()
	{
		let scripts = 0;

		if(this.props.productId)
		{
			let stats = await Api.Staff.Product.Call.stats({
				id: this.props.productId
			});

			if(stats.data)
			{
				scripts = stats.data.scripts;
			}
		}

		App.open(() => <ProductDelete onDelete={this.props.onDelete} scripts={scripts ?? 0} />, false);
	}

	async componentDidMount()
	{
		if(this.props.preset)
		{
			let preset = this.props.preset;
			
			this.form_name.modify(preset.name);
			this.form_brand_name.modify(preset.brand);
			this.form_category_name.modify(preset.category);
			this.form_desc.modify(preset.description);
			this.form_options.modify(preset.options);
			this.form_taxes.modify(preset.taxes);
			this.form_visibility.modify(preset.visibility);
			this.form_cart_limit.modify([!!preset.cart_max, (preset.cart_max ?? 0).toString()]);
			this.form_image.modify({file_id: preset.image_id, file_name: preset.image_name});
		}

		else
		{
			this.form_visibility.modify("PUBLIC");
			this.form_gst_aud.modify("FULL");
			this.form_vat_gbp.modify("FULL");
			this.form_taxes.modify([]);
			this.form_options.modify([
				{
					amount: 0,
					name: "",
					out_stock: false,
					weight: 0,
				},
			]);
		}

		this.setState({
			ready: true,
		});
	}

	get_product()
	{
		let cart_max = this.form_cart_limit.value;
		let visibility = this.form_visibility.value as SQLEnum.ProductVisibility;

		if(!visibility || this.isCustom())
		{
			visibility = "PRIVATE";
		}

		let item: ItemType = {
			brand: this.form_brand_name.value ?? "",
			category: this.form_category_name.value ?? "",
			description: this.form_desc.value,
			image_id: this.form_image.value?.file_id ?? "",
			image_name: this.form_image.value?.file_name ?? "",
			name: this.form_name.value ?? "",
			options: this.form_options.value ?? [],
			cart_max: ((cart_max && cart_max[0] && cart_max[1]) ? parseInt(cart_max[1]) : 0) ?? 0,
			visibility: visibility,
			taxes: this.form_taxes.value ?? [],
		};

		return item;
	}

	render()
	{
		if(!this.state.ready || !this.form_taxes.value) {
			return <></>;
		}

		return (
			<div className="component-add-product">

				<ProductName form={this.form_name}/>

				{!this.isCustom() ? (
					<>
						<AttribName form={this.form_brand_name} type="BRAND"/>
						<AttribName form={this.form_category_name} type="CATEGORY"/>
					</>
				) : <></>}

				<ProductDescription form={this.form_desc} />
				<ProductOptions form={this.form_options} />
				<ProductTaxes taxes={this.form_taxes.value} onChange={this.form_taxes.modify} />
				<ImagePicker form={this.form_image} />
				<ProductDemo product={this.get_product()} />

				{!this.isCustom() ? (
					<>
						<ProductVisibility form={this.form_visibility} product_id={this.props.getProductId ? this.props.getProductId() : null} />
						<ProductCartLimit form={this.form_cart_limit} />
					</>
				) : <></>}

				<Col className="spacer">
					<Button onClick={() => this.submit()}>
						{this.props.isEdit ? "Update" : "Submit"}
					</Button>
					{this.props.onDelete ? (
						<Button onClick={() => this.delete()}>
							Delete
						</Button>
					) : <></>}
					{this.props.onClose ? (
						<Button onClick={() => {
							if(this.props.onClose) {
								this.props.onClose();
							}
						}}>Close</Button>
					) : <></>}
				</Col>

			</div>
		)
	}
}
